<template>
  <div>
    <el-tabs ref="tabs" v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="Account" name="account">
        <account-index />
      </el-tab-pane>
      <el-tab-pane label="Security" name="security">
        <account-security />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { isOrganisationActive } from "@/lib/utils";

export default {
  name: "Settings",
  components: {
    AccountIndex: () => import("@/components/Settings/AccountProfile.vue"),
    AccountSecurity: () => import("@/components/Settings/AccountSecurity.vue")
  },
  data() {
    return {
      isOrganisationActive: isOrganisationActive(),
      defaultTab: "account",
      activeTab: "account"
    };
  },
  methods: {
    handleTabClick(tab) {
      location.hash = tab.name;
    },

    initTab() {
      const initialTab =
        this.$route.hash !== "" ? this.$route.hash.substr(1) : this.defaultTab;
      setTimeout(() => {
        this.activeTab = initialTab;
      }, 1);
    }
  },

  mounted() {
    this.initTab();
  }
};
</script>

<style lang="scss" scoped></style>
